'use strict';

var SystemStatusFileEventTitles = {
  SHOPPING: 'Shopping',
  INFARE: 'Competitor Fare',
  AVERAGEFARE: 'Average Fare',
  UNIQUEPRESENCE: 'Unique Presence',
  SCHEDULE: 'Schedule',
  ACTIVERECOMMENDATIONS: 'Active Recommendations',
  C2CLOADEDUPSELL: 'C2C',
  P2PLOADEDUPSELL: 'P2P',
  YIELDS: 'Yields',
  FOWEBFARE: 'Web Fare',
  FOFM_CURRENCY_EXCHANGE_RATES: 'Currency Exchange Rates',
  FO_FM_OUTBOUND_REQUEST: 'Fare Recommendations',
  FO_RESOLVED_FARE_TRIGGER: 'Resolved Fare',
  FO_DELTA_LAKE_FARE_LOAD_TRIGGER_WEB: 'Impacted WEB Markets Load',
  FO_DELTA_LAKE_FARE_LOAD_TRIGGER_ATPCO: 'Impacted ATPCO Markets Load',
  BUY_DOWN: 'Buy Down Report',
  INVENTORY: 'Inventory',
  OD_AVAILABILITY: 'Availability',
  PRICE_RECOMMENDATION_BOOKING_CURVE: 'Booking Curve',
  PRICE_RECOMMENDATION_SEASON_ASSIGNMENT: 'Season Assignment',
  PRICE_RECOMMENDATION_FORECASTED_LF: 'Forecasted LF',
  DP_ADJUSTMENT: 'DP Adjustment',
  PRICE_RECOMMENDATION_PNR: 'PNR',
  VM_REPORT: 'VM Report',
  SHOP_REPORT: 'Shopping Summary Report',
  EXCLUDED_RECOMMENDATIONS: 'Excluded Recommendations'
};
module.exports = SystemStatusFileEventTitles;